import { HttpEvent, HttpRequest } from '@angular/common/http';
import { inject, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { GrowthBookRequestBuilder } from '@lentau/core/growth-book/shared/growth-book-request.builder';

export function growthBookInterceptor(
  req: HttpRequest<unknown>,
  next: (req: HttpRequest<unknown>) => Observable<HttpEvent<unknown>>
): Observable<HttpEvent<unknown>> {
  const injector: Injector = inject(Injector);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const modifiedReq: HttpRequest<any> = handleGrowthBookInterceptor(req as HttpRequest<any>, injector);

  return next(modifiedReq);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function handleGrowthBookInterceptor(request: HttpRequest<any>, injector: Injector): HttpRequest<any> {
  const requestBuilder: GrowthBookRequestBuilder = injector.get(GrowthBookRequestBuilder);

  const experiments: string = requestBuilder.getRequestExperiments();

  return request.clone({
    setHeaders: {
      Experiments: experiments,
    },
  });
}
